import React, {useEffect, useState} from "react";
import PdfViewerComponent from "../../components/PdfViewerComponent";
import styles from "./PDFPage.module.css"
import axios from "axios";
import {useParams} from "react-router";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";
import {getConfig} from "../../AppConfig";
import {fetchDocumentAsBlob} from "../../util/documentFetch";
import {db} from "../DispatchPage/db";

interface Params {
    driveid: string
    woid: string
}

const PDFPage = () => {
    const { driveid, woid } = useParams<Params>()
    const { secretkey } = getConfig()
    const [downloadProgress, setDownloadProgress] = React.useState(0)
    const [loadingBackdrop, setLoadingBackdrop] = React.useState({show: false, displayMBDownloaded: false, displayPercent: false})
    const [watchLogoDataURL, setWatchLogoDataURL] = React.useState<string | null>(null)
    const [dialogMsg, setDialogMsg] = React.useState( '');

    const decryptedData = React.useMemo(() => {
        // setLoadingBackdrop({show: true, displayMBDownloaded: true, displayPercent: false});
        const encriptedString = localStorage.getItem('pdfopen-' + driveid + '-' + woid)
        if (!encriptedString) return null;

        const CryptoJS = require("crypto-js");
        const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encriptedString), secretkey);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }, [driveid, woid]);

    const getDBRecord = async (id: string) => {
        try {
            const data = await db.documents.get(id);
            // alert ("Json: " + data);
            return data;
        }
        catch (e) {
            console.log(e)
        }
    }

    const loadDatabaseRecord = async (userGuidToPro) => {
        const record = await getDBRecord(userGuidToPro)
        if (record) {
            return record
        }
        else {
            return undefined
        }
    }

    useEffect(() => {
        if (decryptedData?.nodownload) {
            loadDatabaseRecord(decryptedData.id).then((data) => {
                const data2 = data
                const url = window.URL.createObjectURL(data2.blobData);
                setWatchLogoDataURL(url);
            })
        }
        else if (decryptedData?.driveid) {
            previewDoc()
        }
    }, [decryptedData?.driveid])

    // Cleanup blob URL on unmount to prevent memory leaks
    useEffect(() => {
        return () => {
            if (watchLogoDataURL && watchLogoDataURL.startsWith('blob:')) {
                URL.revokeObjectURL(watchLogoDataURL);
            }
        };
    }, [watchLogoDataURL])

    const previewDoc = React.useCallback(async () => {
        setLoadingBackdrop({show: true, displayMBDownloaded: true, displayPercent: false});
        var body = {};
        if (decryptedData?.driveid && decryptedData?.driveid?.length > 0) {
            body['id'] = decryptedData?.driveid;
        }

        try {
            if (watchLogoDataURL) {
                URL.revokeObjectURL(watchLogoDataURL);
            }
            let { blob } = await fetchDocumentAsBlob(
                body,
                (bytesDownloaded, mbDownloaded) => {
                    setDownloadProgress(mbDownloaded);
                }
            );
            const url = window.URL.createObjectURL(blob);
            blob = null;
            setWatchLogoDataURL(prevUrl => {
                if (prevUrl) {
                    URL.revokeObjectURL(prevUrl);
                }
                return url
            });
        } catch (error) {
            console.error('Failed to fetch document:', error);
        } finally {
            setDownloadProgress(0)
            setLoadingBackdrop({show: false, displayMBDownloaded: false, displayPercent: false});
        }
    }, [decryptedData?.driveid]);


    const saveDocumentCallback = async (documentItem) => {
        setDownloadProgress(null)
        setLoadingBackdrop({show: true, displayMBDownloaded: false, displayPercent: true})

        const formData = new FormData();
        formData.append('file', documentItem.blob, 'document.pdf');
        formData.append('GUID', '');
        if (decryptedData?.woid > 0) {
            formData.append('woid', decryptedData?.woid)
        }
        if (decryptedData?.mimetype?.length > 0) {
            formData.append('mimetype', decryptedData?.mimetype)
        }
        if (decryptedData?.filename?.length > 0) {
            formData.append('filename', decryptedData?.filename)
        }
        if (typeof decryptedData?.issaveasbuilt == "boolean") {
            formData.append('IsSaveAsBuilt', decryptedData?.issaveasbuilt)
        }
        if (decryptedData?.driveid && decryptedData?.driveid?.length > 0) {
            formData.append('id', decryptedData?.driveid)
        }
        if (decryptedData?.generalformsid > 0) {
            formData.append('generalformsid', decryptedData?.generalformsid)
        }

        axios.put(`api/documentsbloboverwrite`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                debugger
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                if (percentCompleted > 0) {
                    setDownloadProgress(percentCompleted)
                }
            }
        }).then((response) => {
            const data = JSON.parse(response.data.jsonString)
            setDownloadProgress(0)
            setLoadingBackdrop({show: false, displayMBDownloaded: false, displayPercent: false})
            if (data.status == 'failure') {
                setDialogMsg(data.message)
            }
            documentItem.blob = null;
        }).catch(error => {
            if (error.response) {
                setDialogMsg(error?.response?.data?.title)
            } else if (error.request) {
                setDialogMsg(error.request)
            } else {
                setDialogMsg(error.message)
            }
            documentItem.blob = null;
            // documentItem.setLoadingBackdrop(false)
            setDownloadProgress(0)
            setLoadingBackdrop({show: false, displayMBDownloaded: false, displayPercent: false})
        })
    }

    const closeDialog = () => {
        setDialogMsg("")
    }

    return (
        <div className={styles.root}>
            <>
                <Dialog
                    open={dialogMsg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Ok</Button>
                    </DialogActions>
                </Dialog>
                {watchLogoDataURL != null &&
                    <PdfViewerComponent
                        save={decryptedData?.save}
                        item={{allowsave: decryptedData?.save}}
                        woid={decryptedData?.woid}
                        readonly={decryptedData?.readonly}
                        filename={decryptedData.filename}
                        generalformsgoogledriveid={decryptedData?.driveid}
                        generalformsid={decryptedData?.generalformsid}
                        saveDocumentCallback={saveDocumentCallback}
                        issaveasbuilt={decryptedData?.issaveasbuilt}
                        document={watchLogoDataURL}
                        decryptedData={decryptedData}
                    />
                }
                <LoadingBackdrop open={loadingBackdrop.show} displayMBDownloaded={loadingBackdrop.displayMBDownloaded} displayPercent={loadingBackdrop.displayPercent} mbDownloaded={downloadProgress}/>
            </>
        </div>
    );
}

export default PDFPage
